export const REDUCER_NAME = 'resources';

export const QUERY_PARAMS = {
  CITATION_SELECTED_ID: 'citation_selected_id',
  SHELF_SELECTED_ID: 'shelf_selected_id'
};
